var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(_vm.style)},_vm._l((_vm.users),function(user){return _c('user-avatar',{key:user.id,attrs:{"userInfo":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }